"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DashboardAdd_1 = require("./DashboardAdd");
var DashboardAddStore = new DashboardAdd_1.DashboardAdd();
exports.DashboardAddStore = DashboardAddStore;
